export default __webpack_public_path__ + "static/media/in-mn.5789d528.svg";